<template>
    <a ref="root" href="#top" class="top-button">nach oben</a>
</template>

<script>
import { mapGetters } from 'vuex';
import TopButton from '@/external/assorted/TopButton';

export default {
    data() {
        return {};
    },
    components: {},
    methods: {},
    computed: {
        ...mapGetters(['editorMode'])
    },
    created() {},
    mounted() {
        if (this.editorMode) {
            let i = new TopButton();
            i.init(this.$refs.root);
        }
    },
    props: {}
};
</script>
